import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/nft-new/nft_discover.webp";
import { StaticImage } from "gatsby-plugin-image";

function Nftdiscover() {
  return (
    <section
      className="nft_discover"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Want to Discover Your NFT Potential?</h2>
            <p>
              Collaborate with us and our NFT experts to assist you with a
              suitable solution considering your needs and vision.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Consultation Today!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="offfset-lg-1">
            <div className="nft_discover_img">
              <StaticImage
                src="../../images/services-usa/nft-new/nft_discover_cube _new.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={944}
                height={845}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nftdiscover;
